import {getFeatured, getSelected, getSelectedMoved} from 'actionCreators/comparableItems';
import * as ComparableListingsActions from 'actionCreators/comparableListings';
import * as ComparableRentalsActions from 'actionCreators/comparableRentals';
import * as ComparableSalesActions from 'actionCreators/comparableSales';
import {connect} from 'react-redux';
import SelectedComparableList from './SelectedComparableList';
import {COMPARABLE_TYPES} from 'constants/comparableTypes';

const comparableActions = {
  [COMPARABLE_TYPES.listings]: ComparableListingsActions,
  [COMPARABLE_TYPES.sales]: ComparableSalesActions,
  [COMPARABLE_TYPES.rentals]: ComparableRentalsActions,
};

const mapStateToProps = (state, ownProps) => {
  return {
    comparableType: ownProps.comparableType,
    featureFlags: state.featureFlags,
    selected: getSelected(state, ownProps.comparableType) || [],
    featured: getFeatured(state, ownProps.comparableType) || [],
    settings: state.settings,
    active: ownProps.active,
    selectedMoved: getSelectedMoved(state, ownProps.comparableType)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const actions = comparableActions[ownProps.comparableType];
  return {
    onSortEnd: (oldIndex, newIndex) => {
      dispatch(actions.moveSelected(oldIndex, newIndex));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectedComparableList);